angular.module('workflow.app')
  .filter 'numberSuffix', () ->
    return (input) ->
      suffixes = ['k', 'M', 'G', 'T', 'P', 'E']
      if !input? || window.isNaN(input)
        return null
      if Math.abs(input) < 1000
        return input.toString()

      exp = Math.floor(Math.log(Math.abs(input)) / Math.log(1000))
      (input / Math.pow(1000, exp)).toFixed(1) + suffixes[exp - 1]
